var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import styled from "styled-components";
var sizeToPx = [0, 2, 5, 10, 15, 18, 25, 30, 50, 70, 95, 135];
/*
  Our margin padding system
  1 => 2
  2 => 5
  3 => 10
  4 => 15
  5 => 18
  6 => 25
  7 => 30
  8 => 50
  9 => 70
  10 => 95
  11 => 135
 */
var getSizeValue = function (size, currentSizeToPx) {
    if (size === "auto") {
        return size;
    }
    var sign = '';
    if (size < 0) {
        size = Math.abs(size);
        sign = '-';
    }
    return sign + currentSizeToPx[size] + "px";
};
var getZordCssValue = function (size, currentSizeToPx) {
    if (size === void 0) { size = 0; }
    if (currentSizeToPx === void 0) { currentSizeToPx = sizeToPx; }
    return Array.isArray(size)
        ? size.map(function (currentSize) { return getSizeValue(currentSize, currentSizeToPx); }).join(" ")
        : getSizeValue(size, currentSizeToPx);
};
var Zord = styled.div.attrs(function (_a) {
    var marginZord = _a.marginZord, paddingZord = _a.paddingZord, style = _a.style, theme = _a.theme;
    return ({
        style: {
            margin: getZordCssValue(marginZord, theme.zord || sizeToPx),
            padding: getZordCssValue(paddingZord, theme.zord || sizeToPx),
            ...style,
        },
    });
}).withConfig({ displayName: "Zord", componentId: "sc-1irx3wx" })(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var zord = function () {
    var size = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        size[_i] = arguments[_i];
    }
    return function (_a) {
        var theme = _a.theme;
        if (size.length >= 1 && Array.isArray(size[0])) {
            return getZordCssValue(size[0], theme.zord || sizeToPx);
        }
        else {
            return getZordCssValue(size, theme.zord || sizeToPx);
        }
    };
};
export { Zord, zord };
var templateObject_1;
